import classNames from 'classnames';
import PropTypes from 'prop-types';
import Arg from '@livongo/arg';
import MixpanelUtils from '@livongo/utils/mixpanel';
import Button from 'ui/Button';
import Icon from 'ui/Icon';
import {useTranslation} from 'react-i18next';

const ButtonReturn = ({isOneApp, hasIcon, className}) => {
    const {t} = useTranslation();
    const classes = classNames(
        {'ButtonReturn-with-icon': hasIcon},
        'ButtonReturn-root',
        className
    );
    const isProd =
        (window?.process?.env?.TGPS_ENV ?? process.env.NODE_ENV) ===
        'production';
    const returnSubdomain = Arg('returnSubDomain');
    const host = window.location.hostname;

    const onClick = () => {
        MixpanelUtils.track({event: 'dpp.returnToCCM.clicked'});

        const url = isOneApp
            ? isProd && host.endsWith('teladoc.com')
                ? `${
                      window?.process?.env?.ONEAPP_URL ?? process.env.ONEAPP_URL
                  }/condition-management/home`
                : `https://${returnSubdomain}/condition-management/home`
            : window?.process?.env?.MEMBER_PORTAL_URL ??
              process.env.MEMBER_PORTAL_URL;

        window.open(url, '_self');
    };

    return (
        <Button className={classes} onClick={onClick} color="secondary">
            {hasIcon && <Icon name="arrow-left" size={24} />}
            {t(`${isOneApp ? 'returnToCCMHome' : 'returnToDashboard'}`)}
        </Button>
    );
};

ButtonReturn.propTypes = {
    isOneApp: PropTypes.bool,
    hasIcon: PropTypes.bool,
    className: PropTypes.string,
};

ButtonReturn.defaultProps = {
    hasIcon: false,
};

export default ButtonReturn;
